import React from 'react'
import { FastField } from 'formik'
import { IconButton } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import { Space } from '../../layouts'
import { CustomCheckboxField, CustomTextField } from '../../components'

export interface IDataTypeFragment {
  requestIndex: number
  dataTypeIndex: number
  remove: () => void
  isFormDisabled?: boolean
}

export const DataTypeFragment = ({
  requestIndex,
  dataTypeIndex,
  remove,
  isFormDisabled = false,
}: IDataTypeFragment) => (
  <>
    <FastField
      name={`requests.${requestIndex}.dataTypes.${dataTypeIndex}.value`}
      label={`Datatype ${dataTypeIndex + 1}`}
      component={CustomTextField}
      endAdornment={
        <IconButton
          id="remove-data-type"
          onClick={remove}
          disabled={isFormDisabled}
        >
          <Cancel
            fontSize="small"
            color={isFormDisabled ? 'disabled' : 'primary'}
          />
        </IconButton>
      }
      validate={(value) => !value && 'This is a required field'}
      disabled={isFormDisabled}
    />
    <Space pl={4} pr={4}>
      <FastField
        name={`requests.${requestIndex}.dataTypes.${dataTypeIndex}.returnName`}
        label="Return name"
        component={CustomCheckboxField}
        disabled={isFormDisabled}
      />
    </Space>
  </>
)
